(function() {
    var root = document.getElementById('LaserSettingsGuide-template');
    if (!root) return;
    root.className += ' bli-animations-ready';

    var app = root.querySelector('[data-bli-settings-app]');
    var form = root.querySelector('[data-bli-form]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-bli-step]'));
    var nextButton = root.querySelector('[data-bli-next]');
    var backButton = root.querySelector('[data-bli-back]');
    var error = root.querySelector('[data-bli-error]');
    var progressBar = root.querySelector('[data-bli-progress-bar]');
    var stepLabel = root.querySelector('[data-bli-step-label]');
    var totalSteps = steps.length;

    var currentStep = 1;
    var calculatorLaser = 'Diode Laser';
    var calculatorMaterial = 'all';
    var calculatorSpeedUnit = 'mm/s';

    var wattageRanges = {
      'Diode Laser': { min: 10, max: 40, label: 'Diode Laser range: 10W to 40W.' },
      'CO2 Laser':   { min: 25, max: 150, label: 'CO2 Laser range: 25W to 150W.' },
      'Fiber Laser': { min: 10, max: 100, label: 'Fiber Laser range: 10W to 100W.' }
    };


    // ── Machine models per laser type (from official guide) ──────────────
    var machineModels = {
      'Diode Laser': {
        popular: ['xTool S1', 'xTool D1 Pro', 'Creality Falcon2', 'Atomstack A20 Pro', 'Sculpfun S30'],
        software: ['LightBurn', 'xTool Creative Space (XCS)', 'LaserGRBL'],
        note: 'Diode lasers use a blue-light beam and are common in hobby and small-business settings. Most are compatible with LightBurn.'
      },
      'CO2 Laser': {
        popular: ['xTool P2S', 'xTool P3', 'Epilog Fusion Edge', 'Epilog Fusion Pro', 'Universal Laser Systems (ULS) VLS / PLS / ULTRA'],
        software: ['LightBurn (xTool)', 'Epilog Dashboard', 'Universal Control Panel (UCP) / LSM (ULS)'],
        note: 'CO2 lasers use RF metal tubes and are common in professional workshops. ULS and Epilog machines use proprietary software — LightBurn is not directly compatible with those platforms.'
      },
      'Fiber Laser': {
        popular: ['xTool F1 Ultra', 'ComMarker B4', 'ComMarker MOPA', 'Raycus / JPT MOPA systems'],
        software: ['EzCad2 / EzCad3', 'LightBurn Galvo (xTool F1 Ultra, ComMarker)'],
        note: 'Fiber lasers use a galvo scanning head and are the fastest for direct metal marking. Most support EzCad; xTool F1 Ultra and ComMarker B4 also support LightBurn with the Galvo license.'
      }
    };

    // ── Minimum wattage per laser per product/metal category ──────────────
    // BLI101MBAS hard metals (Brass, Copper, Aluminum via BLI101MBAS path)
    var bli101HardMetalMinimum = {
      'Diode Laser': 40,
      'CO2 Laser':   30,
      'Fiber Laser': 30
    };

    // BLI404ABAS (Aluminum only)
    // Diode: 20W minimum | CO2: 30W minimum | Fiber: works at 10W (no minimum restriction)
    var bli404MinimumWattage = {
      'Diode Laser': 20,
      'CO2 Laser':   30,
      'Fiber Laser': 0
    };

    function forceWattageUnit() {
      var wattageUnits = root.querySelectorAll('[data-calc-wattage-unit], .bli-calculator-context label > strong');
      for (var i = 0; i < wattageUnits.length; i++) wattageUnits[i].textContent = 'W';
    }

    function getWattageRange(laserType) {
      return wattageRanges[laserType] || null;
    }

    function applyWattageRange(input, range) {
      if (!input || !range) return;
      input.min = range.min;
      input.max = range.max;
      input.placeholder = String(range.min) + '-' + String(range.max);
    }

    function updateFunnelWattageRange() {
      var range = getWattageRange(getAnswer('laserType'));
      var input = root.querySelector('[data-bli-wattage-input]');
      var rangeText = root.querySelector('[data-bli-wattage-range]');
      if (range) {
        applyWattageRange(input, range);
        if (rangeText) rangeText.textContent = range.label;
      } else if (rangeText) {
        rangeText.textContent = 'Select a laser type to see the recommended wattage range.';
      }
    }

    function isWattageInRange(laserType, value) {
      var range = getWattageRange(laserType);
      var wattage = Number(value);
      if (!range) return Boolean(value);
      return Boolean(value) && wattage >= range.min && wattage <= range.max;
    }

    // Is wattage sufficient for hard metals with BLI101MBAS?
    function isBli101HardMetalCompatible(laserType, value) {
      var min = bli101HardMetalMinimum[laserType] || 0;
      return Boolean(min) && Boolean(value) && Number(value) >= min;
    }

    function getBli101HardMetalWarning(laserType) {
      var min = bli101HardMetalMinimum[laserType] || 0;
      var msgs101 = {
        'Diode Laser': 'BLI101MBAS on hard metals (brass, copper) requires minimum 40W Diode.',
        'CO2 Laser':   'BLI101MBAS on hard metals requires minimum 30W CO2. Not recommended below 30W.',
        'Fiber Laser': 'BLI101MBAS on hard metals requires minimum 30W Fiber.'
      };
      return msgs101[laserType] || 'BLI101MBAS requires at least ' + min + 'W for ' + laserType + '.';
    }

    function getBli404Minimum(laserType) {
      return bli404MinimumWattage[laserType] || 0;
    }

    function isBli404Compatible(laserType, value) {
      var min = getBli404Minimum(laserType);
      if (min === 0) return true; // Fiber: no minimum restriction
      return Boolean(min) && Boolean(value) && Number(value) >= min;
    }

    function getBli404Warning(laserType) {
      var min = getBli404Minimum(laserType);
      if (!min) return 'BLI404ABAS is not recommended for this laser setup.';
      var msgs = {
        'Diode Laser': 'BLI404ABAS requires minimum 20W Diode laser. Not recommended below 20W.',
        'CO2 Laser':   'BLI404ABAS is not recommended below 30W CO2. Use a 30W or higher CO2 machine.',
        'Fiber Laser': 'BLI404ABAS works on Fiber laser at 10W output — no minimum wattage restriction.'
      };
      return msgs[laserType] || 'BLI404ABAS black aluminum marking requires at least ' + min + 'W for ' + laserType + '.';
    }

    // Is a material a "hard metal" requiring minimum wattage for BLI101MBAS?
    function isHardMetal(material) {
      return material === 'Brass' || material === 'Copper' || material === 'Aluminum';
    }

    var CDN = 'https://brilliancelaserinks.com/cdn/shop/files/';

    var productData = {
      BLI101MBAS: {
        name: 'BLI101MBAS - Black Metal Marking Aerosol Spray',
        shortName: 'BLI101MBAS',
        description: 'For black marking on stainless steel, brass, copper, and compatible metal grades. Hard metals (brass, copper) require minimum wattage.',
        bestFor: ['Stainless steel (all supported lasers)', 'Brass (min 40W Diode / 30W CO2 / 30W Fiber)', 'Copper (min 40W Diode / 30W CO2 / 30W Fiber)', 'Compatible bare metals only'],
        image: CDN + 'black-metal-laser-spray-can-12oz-aerosol-aerosol-brilliance-laser-inks-llc-buy-1-for-4895-713728.jpg?v=1727902250&width=720',
        shopUrl: 'https://brilliancelaserinks.com/collections/shop-now/products/aerosol-spray-can-for-metals-marking-with-co2-fiber-yag',
        docsUrl: '#'
      },
      BLI404ABAS: {
        name: 'BLI404ABAS - Aluminum Laser Marking Spray',
        shortName: 'BLI404ABAS',
        description: 'Only for black marking on aluminum metals. Minimum wattage required: 40W Diode, 50W CO2, or 30W Fiber.',
        bestFor: ['Aluminum metals only', 'Permanent black marking', 'Min 40W Diode / 50W CO2 / 30W Fiber'],
        image: CDN + 'black-aluminum-laser-marking-spray-can-12oz-aerosol-aerosol-brilliance-laser-inks-llc-614249.jpg?v=1727902259&width=720',
        shopUrl: 'https://brilliancelaserinks.com/collections/shop-now/products/black-aluminum-laser-spray-can-12oz-aerosol',
        docsUrl: '#'
      },
      BLI201MRAS: {
        name: 'BLI201MRAS - Red/Copper-Tone Marking Product',
        shortName: 'BLI201MRAS',
        description: 'Only for red/copper-tone marking on stainless steel. Not compatible with other metals, glass, or ceramic.',
        bestFor: ['Stainless steel only', 'Red / copper-tone marking', 'Decorative stainless steel marks'],
        image: CDN + 'red-copper-tone-stainless-steel-laser-spray-can-12oz-aerosol-aerosol-brilliance-laser-inks-llc-498970.jpg?v=1727902292&width=720',
        shopUrl: 'https://brilliancelaserinks.com/collections/shop-now/products/red-copper-tone-metal-laser-spray-can-12oz-aerosol',
        docsUrl: '#'
      },
      BLI420CGBA: {
        name: 'BLI420CGBA - Ceramic & Glass Black Marking Spray',
        shortName: 'BLI420CGBA',
        description: 'Only for black marking on compatible ceramic and glass surfaces. Not compatible with metals.',
        bestFor: ['Ceramic only', 'Glass only', 'Black marking on compatible non-metal surfaces'],
        image: CDN + 'ceramic-and-glass-black-marking-spray-12oz-aerosol-aerosol-brilliance-laser-inks-968998.jpg?v=1727902283&width=720',
        shopUrl: 'https://brilliancelaserinks.com/collections/shop-now/products/ceramic-and-glass-black-marking-spray-12oz-aerosol',
        docsUrl: '#'
      }
    };

    // ── Settings data ──────────────────────────────────────────────────────
    // Notes updated to reflect thermal conductivity data (W/m·K):
    //   Copper: 385-400 (Very High) — fastest heat dissipation, needs slow speed + max power
    //   Aluminum: 205-235 (High) — high dissipation, needs sustained power
    //   Brass: 105-125 (Medium-High) — moderate dissipation
    //   Stainless Steel: 14-16 (Very Low) — retains heat, bonds most easily
    var settingsData = {
      'Diode Laser': {
        referenceWattage: '40W Creality',
        unit: 'recommended speed units',
        rows: {
          'Stainless Steel': {
            powerText: '100%', speedText: '750-1500 mm/s', passes: '1', frequency: '300-500 DPI', lineInterval: '0.008 in (≈ 300 DPI)',
            hardMetal: false, products: ['BLI101MBAS', 'BLI201MRAS'],
            source: 'Diode Laser (40W Creality) metals table',
            note: 'Remember: Stainless steel has very low thermal conductivity (14–16 W/m·K), meaning it retains heat well and bonds the ink more easily. This is why higher speeds work well here. For red/copper-tone marking, use BLI201MRAS and test toward the higher end of the speed range.',
            grids: [{ sku: 'BLI101MBAS', img: CDN + 'Diode_SS_701e8495-3195-4cbb-9f50-7aeec55a3efd.png?v=1739888322&width=900' }]
          },
          'Brass': {
            powerText: '100%', speedText: '500-1000 mm/s', passes: '1', frequency: '300-500 DPI', lineInterval: '0.008 in (≈ 300 DPI)',
            hardMetal: true, products: ['BLI101MBAS'],
            source: 'Diode Laser (40W Creality) metals table',
            note: 'Remember: Brass has medium-high thermal conductivity (105–125 W/m·K) and dissipates heat faster than stainless steel. Use a slower speed range than stainless to allow enough heat for proper ink bonding. Requires minimum 40W Diode.',
            grids: [{ sku: 'BLI101MBAS', img: CDN + 'Brass_Diode.png?v=1739901397&width=900' }]
          },
          'Copper': {
            powerText: '100%', speedText: '300-750 mm/s', passes: '1-2', frequency: '300-500 DPI', lineInterval: '0.008 in (≈ 300 DPI)',
            hardMetal: true, products: ['BLI101MBAS'],
            source: 'Diode Laser (40W Creality) metals table',
            note: 'Remember: Copper has very high thermal conductivity (385–400 W/m·K) — the highest of common metals. It dissipates heat extremely fast, making it the most challenging material to mark. Use the slowest speed in the range and consider 2 passes if the mark is insufficient. Requires minimum 40W Diode.',
            grids: [{ sku: 'BLI101MBAS', img: CDN + 'Copper_Diode.png?v=1739888322&width=900' }]
          },
          'Aluminum': {
            powerText: '100%', speedText: '400-900 mm/s', passes: '1', frequency: '300-500 DPI', lineInterval: '0.008 in (≈ 300 DPI)',
            hardMetal: true, products: ['BLI404ABAS'],
            source: 'Diode Laser (40W Creality) metals table',
            note: 'Remember: Aluminum has high thermal conductivity (205–235 W/m·K) and dissipates heat quickly. Use a slower speed than stainless steel to ensure the ink bonds properly. Use BLI404ABAS only. Requires minimum 40W Diode.',
            grids: [{ sku: 'BLI404ABAS', img: CDN + 'Alum_Diode.png?v=1739290977&width=900' }]
          },
          'Glass': {
            powerText: '30%', speedText: '30 mm/s', passes: '1', frequency: '300 DPI', lineInterval: '0.08 in (≈ 300 DPI)',
            hardMetal: false, products: ['BLI420CGBA'],
            source: 'Diode Laser (40W Creality) ceramics and glass table',
            note: 'Black marking only. Use BLI420CGBA only — not compatible with metal inks.',
            grids: [{ sku: 'BLI420CGBA', img: CDN + 'Glass_Diode_2.jpg?v=1740150629&width=900' }]
          },
          'Ceramic': {
            powerText: '50%', speedText: '40 mm/s', passes: '1', frequency: '300 DPI', lineInterval: '0.08 in (≈ 300 DPI)',
            hardMetal: false, products: ['BLI420CGBA'],
            source: 'Diode Laser (40W Creality) ceramics and glass table',
            note: 'Black marking only. Use BLI420CGBA only — not compatible with metal inks.',
            grids: [{ sku: 'BLI420CGBA', img: CDN + 'Diode_Ceramic.png?v=1740150629&width=900' }]
          }
        }
      },
      'CO2 Laser': {
        referenceWattage: '50W or 60W ULS',
        unit: 'percent speed',
        rows: {
          'Stainless Steel': {
            powerText: '100% black / 80-100% red-copper', speedText: '1-5% black / 15-30% red-copper', passes: '1', frequency: '300-500 DPI', lineInterval: '0.05–0.085 mm (300–500 DPI)',
            hardMetal: false, products: ['BLI101MBAS', 'BLI201MRAS'],
            source: 'CO2 Laser (50W/60W ULS) metals table',
            note: 'Remember: Stainless steel (14–16 W/m·K) retains heat very well, which is why slower speeds work — the material holds enough heat for reliable bonding. For red/copper-tone, use BLI201MRAS at 80–100% power and 15–30% speed.',
            grids: [{ sku: 'BLI101MBAS', img: CDN + 'CO2-_Stainless_7e77d45e-0f29-428a-945e-48206bc0658b.jpg?v=1730822973&width=900' }]
          },
          'Brass': {
            powerText: '100%', speedText: '1-3%', passes: '1', frequency: '300-500 DPI', lineInterval: '0.05–0.085 mm (300–500 DPI)',
            hardMetal: true, products: ['BLI101MBAS'],
            source: 'CO2 Laser (50W ULS) metals table',
            note: 'Remember: Brass (105–125 W/m·K) dissipates heat moderately fast. Keep speed at the lower end of the range to compensate. Requires minimum 30W CO2.',
            grids: [{ sku: 'BLI101MBAS', img: CDN + 'CO2-_Brass-Recovered_copy.jpg?v=1730823517&width=900' }]
          },
          'Copper': {
            powerText: '100%', speedText: '1-2%', passes: '1-2', frequency: '300-500 DPI', lineInterval: '0.05–0.085 mm (300–500 DPI)',
            hardMetal: true, products: ['BLI101MBAS'],
            source: 'CO2 Laser (50W ULS) metals table',
            note: 'Remember: Copper (385–400 W/m·K) is the most thermally conductive common metal and will dissipate laser heat extremely fast. Use the slowest speed setting (1%) and consider 2 passes if the first pass does not produce a clear mark. Requires minimum 30W CO2.',
            grids: [{ sku: 'BLI101MBAS', img: CDN + 'CO2-_Copper_eb263af6-7b26-43f9-af94-b3995d1a74dd.jpg?v=1730823041&width=900' }]
          },
          'Aluminum': {
            powerText: '100%', speedText: '1-3%', passes: '1', frequency: '300-500 DPI', lineInterval: '0.05–0.085 mm (300–500 DPI)',
            hardMetal: true, products: ['BLI404ABAS'],
            source: 'CO2 Laser (50W/60W ULS) aluminum table',
            note: 'Remember: Aluminum (205–235 W/m·K) dissipates heat quickly. Keep speed slow to allow sufficient dwell time for ink bonding. Use BLI404ABAS only. Requires minimum 30W CO2 — not recommended below 30W.',
            grids: [{ sku: 'BLI404ABAS', img: CDN + 'CO2-_Aluminum_404.jpg?v=1730824052&width=900' }]
          },
          'Glass': {
            powerText: '10-13%', speedText: '20-35 mm/s', passes: '1', frequency: '300 DPI', lineInterval: '0.085 mm',
            hardMetal: false, products: ['BLI420CGBA'],
            source: 'CO2 Laser (80W) ceramics and glass test grid',
            note: 'Remember: Glass requires LOW power and LOW-to-MODERATE speed. Based on our 80W CO2 test grid: best results at 10–12.5% power, 20–30 mm/s, 0.085 mm interval. Scale power slightly lower for 50–60W machines. Use BLI420CGBA only.',
            grids: [{ sku: 'BLI420CGBA', img: CDN + 'CO2_-_Glass.jpg?v=1728571560&width=900' }]
          },
          'Ceramic': {
            powerText: '10-15%', speedText: '20-40 mm/s', passes: '1', frequency: '300 DPI', lineInterval: '0.085 mm',
            hardMetal: false, products: ['BLI420CGBA'],
            source: 'CO2 Laser (80W) ceramics and glass test grid',
            note: 'Remember: Ceramic also requires LOW power and MODERATE speed — similar principles to glass. Start at 10% power and 30 mm/s. Increase power in small increments if the mark is too light. Higher speed (40 mm/s) reduces heat buildup on thinner ceramic. Use BLI420CGBA only — not compatible with metal inks.',
            grids: [{ sku: 'BLI420CGBA', img: CDN + 'CO2-_Ceramics.jpg?v=1728571532&width=900' }]
          }
        }
      },
      'Fiber Laser': {
        referenceWattage: '20W fiber',
        unit: 'mm/s',
        rows: {
          'Stainless Steel': {
            powerText: '10%', speedText: '50 mm/s', passes: '1',
            frequency: '200-500 kHz (if max ≤80 kHz, use 50 kHz)',
            lineInterval: '0.1 mm hatch, 0°, no cross-hatch',
            hardMetal: false, products: ['BLI101MBAS', 'BLI201MRAS'],
            source: 'Fiber Laser (20W) metal table',
            note: 'Stainless steel (14–16 W/m·K) retains heat well — ideal for fiber marking. Use 200–500 kHz frequency. If your machine\'s maximum frequency is 80 kHz or below, use 50 kHz and keep speed at 50 mm/s. Recommended hatch: 0.1 mm, 0°, no cross-hatch. For red/copper-tone marking use BLI201MRAS.',
            grids: [{ sku: 'BLI101MBAS', img: CDN + 'Fiber-_Stainless.jpg?v=1727888048&width=900' }]
          },
          'Brass': {
            powerText: '10%', speedText: '30-50 mm/s', passes: '1',
            frequency: '200-500 kHz (if max ≤80 kHz, use 50 kHz)',
            lineInterval: '0.1 mm hatch, 0°, no cross-hatch',
            hardMetal: true, products: ['BLI101MBAS'],
            source: 'Fiber Laser (20W) metal table',
            note: 'Brass (105–125 W/m·K) dissipates heat moderately. Use slower speed than stainless steel. If your machine\'s max frequency is ≤80 kHz, use 50 kHz at 50 mm/s. Recommended hatch: 0.1 mm, 0°, no cross-hatch. Requires minimum 30W Fiber.',
            grids: [{ sku: 'BLI101MBAS', img: CDN + 'Fiber-_Stainless.jpg?v=1727888048&width=900' }]
          },
          'Copper': {
            powerText: '10%', speedText: '10-30 mm/s', passes: '1-2',
            frequency: '200-500 kHz (if max ≤80 kHz, use 50 kHz)',
            lineInterval: '0.1 mm hatch, 0°, no cross-hatch',
            hardMetal: true, products: ['BLI101MBAS'],
            source: 'Fiber Laser (20W) metal table',
            note: 'Copper (385–400 W/m·K) is the most challenging metal — very high heat dissipation. Use slowest speed. Add a second pass if mark is weak. If max frequency ≤80 kHz, use 50 kHz at 50 mm/s. Recommended hatch: 0.1 mm, 0°, no cross-hatch. Requires minimum 30W Fiber.',
            grids: [{ sku: 'BLI101MBAS', img: CDN + 'Fiber-_Stainless.jpg?v=1727888048&width=900' }]
          },
          'Aluminum': {
            powerText: '10%', speedText: '20-40 mm/s', passes: '1',
            frequency: '200-500 kHz (if max ≤80 kHz, use 50 kHz)',
            lineInterval: '0.1 mm hatch, 0°, no cross-hatch',
            hardMetal: false, products: ['BLI404ABAS', 'BLI101MBAS'],
            source: 'Fiber Laser (20W) metal table',
            note: 'Aluminum (205–235 W/m·K) dissipates heat quickly. BLI404ABAS is the primary recommendation and works at 10W output — no minimum wattage restriction on fiber. BLI101MBAS can also be used on bare aluminum. If max frequency ≤80 kHz, use 50 kHz at 50 mm/s. Recommended hatch: 0.1 mm, 0°, no cross-hatch.',
            grids: [
              { sku: 'BLI404ABAS', img: CDN + 'Fiber-_Aluminum.jpg?v=1727888048&width=900' },
              { sku: 'BLI101MBAS', img: CDN + 'Fiber-_Stainless.jpg?v=1727888048&width=900' }
            ]
          },
          'Glass': {
            powerText: '10%', speedText: '1200 mm/s', passes: '1', frequency: '80-400 kHz', lineInterval: '0.1 mm hatch, 0 deg, no cross',
            hardMetal: false, products: ['BLI420CGBA'],
            source: 'Fiber Laser (20W) ceramics and glass table',
            note: 'Black marking only. Power capped at 10% maximum. Use BLI420CGBA only — not compatible with metal inks.',
            grids: [{ sku: 'BLI420CGBA', img: CDN + 'Fiber-_Glass_df232ea6-c2b5-4338-bf67-b01a1ef040f7.jpg?v=1728059063&width=900' }]
          },
          'Ceramic': {
            powerText: '10%', speedText: '1000 mm/s', passes: '1', frequency: '80-400 kHz', lineInterval: '0.1 mm hatch, 0 deg, no cross',
            hardMetal: false, products: ['BLI420CGBA'],
            source: 'Fiber Laser (20W) ceramics and glass table',
            note: 'Black marking only. Power capped at 10% maximum. Use BLI420CGBA only — not compatible with metal inks.',
            grids: [{ sku: 'BLI420CGBA', img: CDN + 'Fiber-_Ceramics_d67cebae-0f7e-4c39-afb6-fdb18c52874f.jpg?v=1728059088&width=900' }]
          }
        }
      }
    };

    function getAnswer(name) {
      var field = form.elements[name];
      if (!field) return '';
      if (typeof RadioNodeList !== 'undefined' && field instanceof RadioNodeList) return field.value;
      return field.value;
    }

    function getCurrentRow() {
      var laserData = settingsData[getAnswer('laserType')];
      return laserData && laserData.rows[getAnswer('material')] ? laserData.rows[getAnswer('material')] : null;
    }

    function getRecommendedGrid() {
      var row = getCurrentRow();
      var productKey = recommendProductKey();
      if (!productKey) return null;
      if (!row || !row.grids || !row.grids.length) return null;
      for (var i = 0; i < row.grids.length; i++) {
        if (row.grids[i].sku === productKey) return row.grids[i];
      }
      return row.grids[0];
    }

    // ── Core recommendation logic ─────────────────────────────────────────
    // Returns product key string, '' if wattage too low, or 'MISMATCH' if
    // user picked a product incompatible with their chosen material.
    function recommendProductKey() {
      var material   = getAnswer('material');
      var markResult = getAnswer('markResult');
      var laserType  = getAnswer('laserType');
      var wattage    = getAnswer('wattage');
      var selected   = getAnswer('product'); // what user picked in step 5


      // Coated or anodized materials — not compatible
      if (material === 'Coated / Anodized Metal') return 'COATED';
      if (material === 'Other / Not sure') return 'UNKNOWN';

      // Glass / Ceramic → BLI420CGBA only
      if (material === 'Glass' || material === 'Ceramic') {
        if (selected && selected !== 'BLI420CGBA' && selected !== "I have not purchased yet" && selected !== "I'm not sure") return 'MISMATCH';
        return 'BLI420CGBA';
      }

      // Aluminum → BLI404ABAS only
      if (material === 'Aluminum') {
        if (selected && selected !== 'BLI404ABAS' && selected !== "I have not purchased yet" && selected !== "I'm not sure") return 'MISMATCH';
        return isBli404Compatible(laserType, wattage) ? 'BLI404ABAS' : '';
      }

      // Brass / Copper → BLI101MBAS only
      if (material === 'Brass' || material === 'Copper') {
        if (selected && selected !== 'BLI101MBAS' && selected !== "I have not purchased yet" && selected !== "I'm not sure") return 'MISMATCH';
        return isBli101HardMetalCompatible(laserType, wattage) ? 'BLI101MBAS' : '';
      }

      // Stainless Steel → BLI101MBAS or BLI201MRAS
      if (material === 'Stainless Steel') {
        if (selected && selected !== 'BLI101MBAS' && selected !== 'BLI201MRAS' && selected !== "I have not purchased yet" && selected !== "I'm not sure") return 'MISMATCH';
        if (markResult === 'Red / copper-tone mark') return 'BLI201MRAS';
        return 'BLI101MBAS';
      }

      return 'BLI101MBAS';
    }

    // Returns a human-friendly mismatch message based on material and selected product
    function getMismatchMessage(material, selectedProduct) {
      var productName = productData[selectedProduct] ? productData[selectedProduct].shortName : selectedProduct;

      if (material === 'Aluminum') {
        return productName + ' is not compatible with Aluminum. For marking Aluminum metals, we recommend BLI404ABAS instead.';
      }
      if (material === 'Brass') {
        return productName + ' is not compatible with Brass. For marking Brass, we recommend BLI101MBAS instead.';
      }
      if (material === 'Copper') {
        return productName + ' is not compatible with Copper. For marking Copper, we recommend BLI101MBAS instead.';
      }
      if (material === 'Glass') {
        return productName + ' is not compatible with Glass. For marking Glass surfaces, we recommend BLI420CGBA instead.';
      }
      if (material === 'Ceramic') {
        return productName + ' is not compatible with Ceramic. For marking Ceramic surfaces, we recommend BLI420CGBA instead.';
      }
      if (material === 'Stainless Steel') {
        return productName + ' is not compatible with Stainless Steel in this configuration. For black marking use BLI101MBAS, or for a red/copper-tone mark use BLI201MRAS.';
      }
      return productName + ' is not compatible with ' + material + '. Please contact support for the correct product recommendation.';
    }

    function calculateRowSettings(laserType, row, userWattage) {
      var laserData = settingsData[laserType];
      if (laserData && row) {
        var powerDisplay = row.powerText;

        /**
         * Fiber laser — Requirement 2:
         * Target output is always 10W regardless of machine size.
         * Required % = (10W ÷ machineWatts) × 100
         *
         * Examples:
         *   20W machine  → (10 ÷ 20) × 100 = 50%
         *   50W machine  → (10 ÷ 50) × 100 = 20%
         *   100W machine → (10 ÷ 100) × 100 = 10%
         */
        if (laserType === 'Fiber Laser' && userWattage && Number(userWattage) > 0) {
          var userW       = Number(userWattage);
          var TARGET_W    = 10; // always target 10W output
          var requiredPct = roundSpeed((TARGET_W / userW) * 100);
          powerDisplay    = requiredPct + '%';
        }

        return {
          power: powerDisplay,
          speed: row.speedText,
          passes: row.passes,
          frequency: row.frequency,
          lineInterval: row.lineInterval,
          referenceWattage: laserData.referenceWattage,
          speedUnit: laserData.unit,
          source: row.source,
          note: row.note || ''
        };
      }
      return null;
    }

    function getSettings() {
      var laserType = getAnswer('laserType');
      var material  = getAnswer('material');
      var laserData = settingsData[laserType];
      var row = laserData && laserData.rows[material];
      var calculated = calculateRowSettings(laserType, row, getAnswer('wattage'));
      if (calculated) return calculated;

      var defaults = {
        'Fiber Laser': { speedUnit: 'mm/s' },
        'CO2 Laser':   { speedUnit: 'percent speed' },
        'Diode Laser': { speedUnit: 'recommended speed units' }
      };
      var def = defaults[laserType] || {};
      return { power: 'Use test grid', speed: 'Use test grid', passes: '1', frequency: 'Use machine default', lineInterval: 'Use test grid', referenceWattage: 'No exact match', speedUnit: def.speedUnit || '-' };
    }

    function setText(selector, value) {
      var el = root.querySelector(selector);
      if (el) el.textContent = value || '-';
    }

    function hasClass(el, cls) { return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1; }
    function addClass(el, cls) { if (!hasClass(el, cls)) el.className = el.className ? el.className + ' ' + cls : cls; }
    function removeClass(el, cls) { el.className = (' ' + el.className + ' ').replace(' ' + cls + ' ', ' ').replace(/^\s+|\s+$/g, ''); }

    function updateHelpers() {
      var unsureLaser    = getAnswer('laserType') === "I'm not sure";
      var unsureMaterial = getAnswer('material') === 'Other / Not sure';
      var redTone        = getAnswer('markResult') === 'Red / copper-tone mark';
      var material       = getAnswer('material');
      var limitedMark    = redTone && material && material !== 'Stainless Steel';

      root.querySelector('[data-helper-for="laserType"]').hidden = !unsureLaser;
      root.querySelector('[data-helper-for="material"]').hidden = !unsureMaterial;
      root.querySelector('[data-helper-for="markResult"]').hidden = !redTone;
      var availabilityHint = root.querySelector('[data-helper-for="markAvailability"]');
      var showAvailability = limitedMark && material !== 'Glass' && material !== 'Ceramic';
      availabilityHint.hidden = !showAvailability;
      if (showAvailability) {
        availabilityHint.textContent = 'Red / copper-tone marking is only available for Stainless Steel. ' + material + ' does not support red / copper-tone marking — please select "High-contrast black mark" instead.';
      }

      var productChoice  = getAnswer('product');
      var recommendation = root.querySelector('[data-bli-step-recommendation]');
      var productKey     = recommendProductKey();
      var product        = productData[productKey];
      var shouldShow     = productChoice === 'I have not purchased yet' || productChoice === "I'm not sure";

      recommendation.hidden = !shouldShow;
      if (shouldShow && product) {
        root.querySelector('[data-bli-inline-product]').textContent = product.name;
        root.querySelector('[data-bli-inline-shop]').href = product.shopUrl || '#';
      } else if (shouldShow && !productKey) {
        var laserType = getAnswer('laserType');
        var msg = (material === 'Aluminum') ? getBli404Warning(laserType) : getBli101HardMetalWarning(laserType);
        root.querySelector('[data-bli-inline-product]').textContent = msg;
        root.querySelector('[data-bli-inline-shop]').href = 'https://brilliancelaserinks.com/pages/contact-us';
      } else if (shouldShow && productKey === 'MISMATCH') {
        root.querySelector('[data-bli-inline-product]').textContent = getMismatchMessage(material, getAnswer('product'));
        root.querySelector('[data-bli-inline-shop]').href = 'https://brilliancelaserinks.com/pages/contact-us';
      }
      updateFunnelWattageRange();
    }

    function roundSpeed(value) { return Math.round(value * 100) / 100; }

    /**
     * updateWattageOutput — Live calculator wattage output display
     * Business rules:
     *   CO2 / Diode: Actual Watts = Power% × Machine Wattage
     *   Fiber:       Target output is always 10W (fixed).
     *                Required % = (10W / Machine Wattage) × 100
     *
     * @param {string} laserType  - 'Diode Laser' | 'CO2 Laser' | 'Fiber Laser'
     * @param {number} machineW   - Machine's total wattage capacity
     */
    function updateWattageOutput(laserType, machineW) {
      var outputEl    = root.querySelector('[data-calc-output]');
      var outputVal   = root.querySelector('[data-calc-output-value]');
      var outputLabel = root.querySelector('[data-calc-output-label]');
      if (!outputEl || !outputVal || !outputLabel) return;

      outputEl.setAttribute('data-laser', laserType);

      if (!machineW || machineW <= 0) {
        outputVal.innerHTML = '—';
        outputLabel.textContent = 'Recommended power output';
        return;
      }

      if (laserType === 'Fiber Laser') {
        // Fiber: target is always 10W — show required % for this machine
        var TARGET_W       = 10;
        var requiredPct    = roundSpeed((TARGET_W / machineW) * 100);
        outputLabel.textContent = 'Set this power for 10W output';
        outputVal.innerHTML = requiredPct + '%'
          + '<span class="bli-calc-output-sub">' + requiredPct + '% × ' + machineW + 'W = 10W</span>';
      } else {
        // CO2 / Diode: show actual watts from recommended % × machine wattage
        // Get the first table row's power % for the active material filter
        var firstRow = root.querySelector('[data-bli-calculator-body] tr td:nth-child(2)');
        var powerPct = firstRow ? firstRow.textContent.replace('%','').trim() : null;
        if (powerPct && !isNaN(Number(powerPct))) {
          var actualW = roundSpeed(Number(powerPct) / 100 * machineW);
          outputLabel.textContent = 'Output at ' + powerPct + '% power';
          outputVal.innerHTML = actualW + 'W'
            + '<span class="bli-calc-output-sub">(' + powerPct + '% × ' + machineW + 'W)</span>';
        } else {
          outputLabel.textContent = 'Recommended power output';
          outputVal.innerHTML = 'See table';
        }
      }
    }



    // Standard max speeds for % conversion (mm/s)
    var CO2_MAX_SPEED_MMS = 500; // ~500 mm/s = 100% on most CO2 machines (ULS, Epilog)

    function convertMmSpeed(text, targetUnit) {
      if (!text) return text;
      var isPercent = text.indexOf('%') > -1;
      var targetIsPercent = targetUnit === 'percentage' || targetUnit === '%';

      // ── Stored as percentage → convert to other units ──
      if (isPercent) {
        if (targetIsPercent) return text;
        // Extract percentage range e.g. "1-5%" or "80-100%"
        var pctMatch = text.match(/(\d+(?:\.\d+)?)(?:\s*[-–]\s*(\d+(?:\.\d+)?))?\s*%/);
        if (!pctMatch) return text;
        var pA = Number(pctMatch[1]) / 100 * CO2_MAX_SPEED_MMS;
        var pB = pctMatch[2] ? Number(pctMatch[2]) / 100 * CO2_MAX_SPEED_MMS : null;
        if (targetUnit === 'mm/s') {
          return pB ? roundSpeed(pA) + '–' + roundSpeed(pB) + ' mm/s'
                    : roundSpeed(pA) + ' mm/s';
        }
        if (targetUnit === 'mm/min') {
          return pB ? roundSpeed(pA * 60) + '–' + roundSpeed(pB * 60) + ' mm/min'
                    : roundSpeed(pA * 60) + ' mm/min';
        }
        if (targetUnit === 'inch/s') {
          return pB ? roundSpeed(pA / 25.4) + '–' + roundSpeed(pB / 25.4) + ' inch/s'
                    : roundSpeed(pA / 25.4) + ' inch/s';
        }
        return text;
      }

      // ── Stored as mm/s → convert to target unit ──
      if (targetIsPercent) {
        return text.replace(/(\d+(?:\.\d+)?)(?:\s*[-–]\s*(\d+(?:\.\d+)?))?\s*mm\/s/g, function(match, first, second) {
          var a = roundSpeed(Number(first) / CO2_MAX_SPEED_MMS * 100);
          var b = second ? roundSpeed(Number(second) / CO2_MAX_SPEED_MMS * 100) : null;
          return b !== null ? a + '–' + b + '%' : a + '%';
        });
      }
      return text.replace(/(\d+(?:\.\d+)?)(?:\s*[-–]\s*(\d+(?:\.\d+)?))?\s*mm\/s/g, function(match, first, second) {
        var a = Number(first), b = second ? Number(second) : null;
        if (targetUnit === 'mm/min') {
          a = roundSpeed(a * 60);
          if (b !== null) b = roundSpeed(b * 60);
          return b !== null ? a + '–' + b + ' mm/min' : a + ' mm/min';
        }
        if (targetUnit === 'inch/s') {
          a = roundSpeed(a / 25.4);
          if (b !== null) b = roundSpeed(b / 25.4);
          return b !== null ? a + '–' + b + ' inch/s' : a + ' inch/s';
        }
        return b !== null ? a + '–' + b + ' mm/s' : a + ' mm/s';
      });
    }

    function renderCalculatorGrids(laserData) {
      var gallery = root.querySelector('[data-calc-grid-gallery]');
      if (!gallery || !laserData) return;
      gallery.innerHTML = '';
      var wattageInput = root.querySelector('[data-calc-wattage]');
      var wattage = wattageInput && wattageInput.value ? Number(wattageInput.value) : '';

      for (var material in laserData.rows) {
        if (!Object.prototype.hasOwnProperty.call(laserData.rows, material)) continue;
        if (calculatorMaterial !== 'all' && calculatorMaterial !== material) continue;
        var row = laserData.rows[material];

        // Skip blocked rows
        if (material === 'Aluminum' && !isBli404Compatible(calculatorLaser, wattage)) continue;
        if (row.hardMetal && material !== 'Aluminum' && !isBli101HardMetalCompatible(calculatorLaser, wattage)) continue;
        if (!row.grids || !row.grids.length) continue;

        for (var gi = 0; gi < row.grids.length; gi++) {
          var grid = row.grids[gi];
          var prod = productData[grid.sku];
          var link = document.createElement('a');
          link.className = 'bli-calculator-grid-item';
          link.href = grid.img;
          link.target = '_blank';
          link.rel = 'noopener';
          link.innerHTML = '<img src="' + grid.img + '" alt="' + laserData.referenceWattage + ' ' + material + ' test grid"><span>' + material + ' - ' + (prod ? prod.shortName : grid.sku) + '</span>';
          gallery.appendChild(link);
        }
      }
      if (!gallery.children.length) {
        gallery.innerHTML = '<p>No test grid image available for this filter. Please contact support for help.</p>';
      }
    }

    function getSpeedOptions(laserType) {
      if (laserType === 'CO2 Laser')   return [{ value: 'mm/s', label: 'mm/s' }, { value: 'mm/min', label: 'mm/min' }, { value: 'inch/s', label: 'inch/s' }, { value: 'percentage', label: 'Percentage' }];
      if (laserType === 'Fiber Laser') return [{ value: 'mm/s', label: 'mm/s' }];
      return [{ value: 'mm/s', label: 'mm/s' }, { value: 'mm/min', label: 'mm/min' }];
    }

    function renderSpeedOptions() {
      var speedOptions = root.querySelector('[data-calc-speed-options]');
      if (!speedOptions) return;
      var options = getSpeedOptions(calculatorLaser);
      var allowed = false;
      for (var i = 0; i < options.length; i++) { if (options[i].value === calculatorSpeedUnit) allowed = true; }
      if (!allowed) calculatorSpeedUnit = options[0].value;
      speedOptions.innerHTML = '';
      for (var j = 0; j < options.length; j++) {
        var opt = options[j];
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('data-calc-speed-unit', opt.value);
        btn.textContent = opt.label;
        if (opt.value === calculatorSpeedUnit) addClass(btn, 'is-active');
        btn.onclick = function() {
          var all = root.querySelectorAll('[data-calc-speed-unit]');
          for (var k = 0; k < all.length; k++) removeClass(all[k], 'is-active');
          addClass(this, 'is-active');
          calculatorSpeedUnit = this.getAttribute('data-calc-speed-unit');
          renderCalculatorTable();
        };
        speedOptions.appendChild(btn);
      }
    }

    // ── Fade irrelevant speed unit pills based on laser type ──
    var relevantUnits = {
      'Diode Laser': ['mm/s', 'mm/min'],
      'CO2 Laser':   ['percentage', 'mm/s', 'mm/min', 'inch/s'],
      'Fiber Laser': ['mm/s']
    };
    var allowed = relevantUnits[calculatorLaser] || ['mm/s'];
    var allPills = root.querySelectorAll('[data-calc-speed-unit]');
    for (var pi = 0; pi < allPills.length; pi++) {
      var pillUnit = allPills[pi].getAttribute('data-calc-speed-unit');
      if (allowed.indexOf(pillUnit) > -1) {
        allPills[pi].classList.remove('bli-faded');
      } else {
        allPills[pi].classList.add('bli-faded');
        if (allPills[pi].classList.contains('is-active')) {
          allPills[pi].classList.remove('is-active');
          // Switch to first allowed unit
          var fallback = root.querySelector('[data-calc-speed-unit="' + allowed[0] + '"]');
          if (fallback) {
            fallback.classList.add('is-active');
            calculatorSpeedUnit = allowed[0];
          }
        }
      }
    }

    function renderCalculatorTable() {
      // ── Update table headers immediately based on laser type ──
      var _isFiberNow = calculatorLaser === 'Fiber Laser';
      var _fhNow = root.querySelector('[data-calc-header="frequency"]');
      var _ihNow = root.querySelector('[data-calc-header="lineInterval"]');
      if (_fhNow) _fhNow.textContent = _isFiberNow ? 'Frequency (kHz)' : 'DPI';
      if (_ihNow) _ihNow.textContent = _isFiberNow ? 'Hatch' : 'Line Interval / Hatch';

      var tbody = root.querySelector('[data-bli-calculator-body]');
      var laserData = settingsData[calculatorLaser];
      var wattageInput = root.querySelector('[data-calc-wattage]');
      var wattage = wattageInput && wattageInput.value ? Number(wattageInput.value) : '';
      var calcRange = getWattageRange(calculatorLaser);
      var calcRangeText = root.querySelector('[data-calc-wattage-range]');

      renderSpeedOptions();
      applyWattageRange(wattageInput, calcRange);
      var cLaser = root.querySelector('[data-calc-context="laser"]');
      var cUnit  = root.querySelector('[data-calc-context="unit"]');
      var cWU    = root.querySelector('[data-calc-wattage-unit]');
      var note   = root.querySelector('[data-calc-note]');
      if (cLaser) cLaser.textContent = calculatorLaser;
      if (cUnit)  cUnit.textContent  = calculatorSpeedUnit === 'percentage' ? 'percentage' : calculatorSpeedUnit;
      if (cWU)    cWU.textContent    = 'W';
      forceWattageUnit();
      if (calcRangeText && calcRange) calcRangeText.textContent = "Note: If your wattage does not fall within the recommended range (" + calcRange.min + 'W–' + calcRange.max + 'W), our inks may not be compatible with your machine.';
      if (note) note.innerHTML = 'Please contact us if you cannot achieve your desired result. We offer <strong>FREE lifetime technical support</strong>.';

      tbody.innerHTML = '';
      for (var material in laserData.rows) {
        if (!Object.prototype.hasOwnProperty.call(laserData.rows, material)) continue;
        if (calculatorMaterial !== 'all' && calculatorMaterial !== material) continue;

        var row = laserData.rows[material];

        // Determine compatibility
        var blocked = false;
        var blockReason = '';
        if (material === 'Aluminum') {
          if (!isBli404Compatible(calculatorLaser, wattage)) {
            blocked = true;
            blockReason = getBli404Warning(calculatorLaser);
          }
        } else if (row.hardMetal) {
          // Brass / Copper
          if (!isBli101HardMetalCompatible(calculatorLaser, wattage)) {
            blocked = true;
            blockReason = getBli101HardMetalWarning(calculatorLaser);
          }
        }

        var calcWattVal = wattageInput && wattageInput.value ? wattageInput.value : '';
        var settings = blocked ? { power: 'Not recommended', speed: 'Not recommended', passes: '-', frequency: '-', lineInterval: '-' } : calculateRowSettings(calculatorLaser, row, calcWattVal);

        // Build product list — filter incompatible ones
        var productNames = [];
        var rowProducts = row.products || [];
        for (var i = 0; i < rowProducts.length; i++) {
          var sku = rowProducts[i];
          // BLI201MRAS only on Stainless Steel
          if (sku === 'BLI201MRAS' && material !== 'Stainless Steel') continue;
          // BLI420CGBA only on Glass/Ceramic
          if (sku === 'BLI420CGBA' && material !== 'Glass' && material !== 'Ceramic') continue;
          // BLI404ABAS only on Aluminum, wattage gated
          if (sku === 'BLI404ABAS' && (material !== 'Aluminum' || !isBli404Compatible(calculatorLaser, wattage))) continue;
          // BLI101MBAS on hard metals, wattage gated
          if (sku === 'BLI101MBAS' && row.hardMetal && !isBli101HardMetalCompatible(calculatorLaser, wattage)) continue;
          productNames.push(productData[sku] ? productData[sku].shortName : sku);
        }
        var productsDisplay = blocked ? ('<em>' + blockReason + '</em>') : (productNames.length ? productNames.join(', ') : 'Not recommended for this configuration');

        var tr = document.createElement('tr');
        tr.innerHTML =
          '<td><strong>' + material + '</strong></td>' +
          '<td>' + settings.power + '</td>' +
          '<td>' + convertMmSpeed(settings.speed, calculatorSpeedUnit) + '</td>' +
          '<td>' + settings.passes + '</td>' +
          '<td>' + settings.frequency + '</td>' +
          '<td>' + settings.lineInterval + '</td>' +
          '<td>' + productsDisplay + '</td>';
        tbody.appendChild(tr);
      }

      renderCalculatorGrids(laserData);

      // Update calculator table headers per laser type
      var calcFreqHeader     = root.querySelector('[data-calc-header="frequency"]');
      var calcIntervalHeader = root.querySelector('[data-calc-header="lineInterval"]');
      var isFiberCalc        = calculatorLaser === 'Fiber Laser';
      if (calcFreqHeader)     calcFreqHeader.textContent     = isFiberCalc ? 'Frequency (kHz)' : 'DPI';
      if (calcIntervalHeader) calcIntervalHeader.textContent = isFiberCalc ? 'Hatch' : 'Line Interval';

      // Update live wattage output display
      var wattVal = wattageInput && wattageInput.value ? Number(wattageInput.value) : 0;
      updateWattageOutput(calculatorLaser, wattVal);
    }

    function updateResults() {
      var productKey = recommendProductKey();
      var material   = getAnswer('material');
      var laserType  = getAnswer('laserType');
      var wattage    = getAnswer('wattage');
      var settings   = getSettings();
      var grid       = getRecommendedGrid();

      var isCoated  = productKey === 'COATED';
      var isUnknown = productKey === 'UNKNOWN';
      var isMismatch = productKey === 'MISMATCH';
      var isBlocked  = productKey === '' || isCoated || isUnknown;
      var product    = (!isMismatch && !isBlocked) ? productData[productKey] : null;

      var blockMsg = '';
      if (isCoated) {
        blockMsg = 'Our products are formulated for bare metal, ceramic, and glass surfaces only. Coated, anodized, or painted metals have a surface layer that blocks the ink from bonding directly to the substrate — the laser marks the coating instead of fusing the ink to the metal beneath. For best results, remove any coating or anodizing before applying Brilliance Laser Inks.';
        settings = { power: 'N/A', speed: 'N/A', passes: 'N/A', frequency: 'N/A', lineInterval: 'N/A', referenceWattage: settings.referenceWattage, speedUnit: settings.speedUnit, note: blockMsg };
      } else if (isUnknown) {
        blockMsg = 'We are not sure if our products are compatible with this material. Please contact support at support@brilliancelaserinks.com for guidance.';
        settings = { power: 'Use test grid', speed: 'Use test grid', passes: '1', frequency: 'N/A', lineInterval: 'N/A', referenceWattage: settings.referenceWattage, speedUnit: settings.speedUnit, note: blockMsg };
      } else if (isMismatch) {
        blockMsg = getMismatchMessage(material, getAnswer('product'));
        settings = { power: 'N/A', speed: 'N/A', passes: 'N/A', frequency: 'N/A', lineInterval: 'N/A', referenceWattage: settings.referenceWattage, speedUnit: settings.speedUnit, note: blockMsg };
      } else if (isBlocked) {
        blockMsg = (material === 'Aluminum') ? getBli404Warning(laserType) : getBli101HardMetalWarning(laserType);
        settings = { power: 'Not recommended', speed: 'Not recommended', passes: '-', frequency: '-', lineInterval: '-', referenceWattage: settings.referenceWattage, speedUnit: settings.speedUnit, note: blockMsg };
      }

      setText('[data-result="laserType"]',    laserType);
      setText('[data-result="wattage"]',      wattage ? wattage + 'W' : '-');
      setText('[data-result="material"]',     material);
      setText('[data-result="product"]',      product ? product.name : (isMismatch ? getAnswer('product') : '-'));
      setText('[data-result="power"]',        settings.power);

      // ── Speed conversion based on customer's chosen unit ──
      var customerSpeedUnit = getAnswer('co2SpeedUnit');
      var displaySpeed = settings.speed;

      // ── Determine speed unit from software choice ──
      var softwareChoice = getAnswer('software');
      var softwareSpeedUnit = customerSpeedUnit; // default from CO2 step
      var softwareNoteText = '';
      var softwareUnitMap = {
        'LightBurn': 'mm/s',
        'xTool Creative Space (XCS)': 'mm/min',
        'LaserGRBL': 'mm/min',
        'RDWorks': 'mm/s',
        'ULS Control Panel (UCP)': 'percentage',
        'Epilog Dashboard': 'percentage',
        'EzCad2 / EzCad3': 'mm/s',
        'LightBurn (Galvo)': 'mm/s'
      };
      var softwareNoteMap = {
        'LightBurn': 'In LightBurn: set Speed in mm/s, Power in %, enable Fill or Line mode.',
        'xTool Creative Space (XCS)': 'In XCS: Speed is shown in mm/min. Power in %.',
        'LaserGRBL': 'In LaserGRBL: Speed is in mm/min. Set $ parameters for power.',
        'RDWorks': 'In RDWorks: Speed in mm/s, Power in %. Use Engrave layer.',
        'ULS Control Panel (UCP)': 'In ULS UCP: Speed is shown as a percentage of maximum. Power in %.',
        'Epilog Dashboard': 'In Epilog Dashboard: Speed and Power both shown as percentage.',
        'EzCad2 / EzCad3': 'In EzCad2/3: Speed in mm/s, Power in %, Frequency in kHz. Use Hatch fill.',
        'LightBurn (Galvo)': 'In LightBurn Galvo: Speed in mm/s, Power in %, Frequency in kHz.'
      };
      if (softwareChoice && softwareUnitMap[softwareChoice]) {
        softwareSpeedUnit = softwareUnitMap[softwareChoice];
      }
      if (softwareChoice && softwareNoteMap[softwareChoice]) {
        softwareNoteText = softwareNoteMap[softwareChoice];
      }
      if (softwareSpeedUnit && laserType !== 'Fiber Laser') {
        displaySpeed = convertMmSpeed(settings.speed, softwareSpeedUnit);
        settings.speedUnit = softwareSpeedUnit;
      }

      setText('[data-result="speed"]', displaySpeed);

      setText('[data-result="passes"]',       settings.passes);
      setText('[data-result="frequency"]',    settings.frequency);
      setText('[data-result="lineInterval"]', settings.lineInterval);

      // Update labels based on laser type — Fiber uses Frequency/kHz, others use DPI
      var isFiber = laserType === 'Fiber Laser';
      var freqLabel     = root.querySelector('[data-result-label="frequency"]');
      var intervalLabel = root.querySelector('[data-result-label="lineInterval"]');
      if (freqLabel)     freqLabel.textContent     = isFiber ? 'Frequency (kHz)' : 'DPI';
      if (intervalLabel) intervalLabel.textContent = isFiber ? 'Hatch' : 'Line Interval';

      // Update calculator table header too
      var calcFreqHeader = root.querySelector('[data-calc-header="frequency"]');
      if (calcFreqHeader) calcFreqHeader.textContent = isFiber ? 'Frequency (kHz)' : 'DPI';
      setText('[data-context="laserType"]',        laserType);
      setText('[data-context="userWattage"]',      wattage ? wattage + 'W' : '-');
      setText('[data-context="speedUnit"]',        settings.speedUnit);
      // Clear any previous mismatch banner
      var prevBanner = root.querySelector('[data-bli-mismatch-banner]');
      if (prevBanner) prevBanner.parentNode.removeChild(prevBanner);

      if (isMismatch) {
        var banner = document.createElement('p');
        banner.setAttribute('data-bli-mismatch-banner', '1');
        banner.style.cssText = 'margin-top:14px;font-style:italic;font-weight:700;color:rgba(255,100,100,0.9);font-size:14px;line-height:1.5;';
        banner.textContent = blockMsg;
        var settingsCard = root.querySelectorAll('.bli-settings-guide__summary')[1];
        if (settingsCard) settingsCard.appendChild(banner);
      }

      // Hide or show notice — never show '-' dash on mismatch
      var noticeEl = root.querySelector('[data-result="settingsNote"]');
      if (noticeEl) {
        if (isMismatch) {
          noticeEl.style.display = 'none';
        } else {
          noticeEl.style.display = '';
          noticeEl.textContent = (settings.note ? settings.note + ' ' : '') + 'These are starting settings only. Always test on scrap material before production.';
        }
      }

      root.querySelector('[data-bli-shop-link]').href    = product ? product.shopUrl : 'https://brilliancelaserinks.com/pages/contact-us';
      root.querySelector('[data-bli-product-shop]').href = product ? product.shopUrl : 'https://brilliancelaserinks.com/pages/contact-us';
      root.querySelector('[data-bli-product-shop]').textContent = product ? 'Shop Now' : 'Contact Support';
      root.querySelector('[data-bli-product-title]').textContent = product ? product.name : (isMismatch ? 'Wrong Product Selected' : 'Wattage Too Low');
      root.querySelector('[data-bli-product-description]').textContent = product ? product.description : blockMsg;

      var productImage = root.querySelector('[data-bli-product-image]');
      if (productImage) {
        if (product && product.image) { productImage.src = product.image; productImage.alt = product.name; productImage.hidden = false; }
        else { productImage.hidden = true; productImage.removeAttribute('src'); }
      }

      // Grid — show inline image directly, downloadable, no button needed
      var gridCard         = root.querySelector('[data-bli-grid-card]');
      var gridImage        = root.querySelector('[data-bli-grid-image]');
      var gridDownloadLink = root.querySelector('[data-bli-grid-image-link]');
      var gridImgLink      = root.querySelector('[data-bli-grid-image-link-img]');
      var laserDataR       = settingsData[laserType];
      var rowR             = laserDataR && laserDataR.rows[material];
      var rowGrids         = (rowR && rowR.grids && rowR.grids.length && !isMismatch) ? rowR.grids : null;
      if (rowGrids) {
        var firstGrid = rowGrids[0];
        var gridProd  = productData[firstGrid.sku] || product;
        var fileName  = laserType.replace(/\s+/g, '-') + '-' + material.replace(/\s+/g, '-') + '-test-grid.jpg';
        gridCard.hidden = false;
        gridImage.src = firstGrid.img;
        gridImage.alt = laserType + ' ' + material + ' test grid';
        if (gridDownloadLink) { gridDownloadLink.href = firstGrid.img; gridDownloadLink.setAttribute('download', fileName); }
        if (gridImgLink)      { gridImgLink.href = firstGrid.img; gridImgLink.setAttribute('download', fileName); }
        root.querySelector('[data-bli-grid-caption]').textContent = laserType + ' test grid for ' + material + (gridProd ? ' — ' + gridProd.name : '') + '. Click the image or button to download.';
      } else {
        gridCard.hidden = true;
      }

      var bestForList = root.querySelector('[data-bli-product-best-for]');
      bestForList.innerHTML = '';
      if (product) {
        for (var i = 0; i < product.bestFor.length; i++) {
          var li = document.createElement('li'); li.textContent = product.bestFor[i]; bestForList.appendChild(li);
        }
      } else {
        var li2 = document.createElement('li'); li2.textContent = blockMsg; bestForList.appendChild(li2);
      }

      // Inject "Start Over" button above action buttons if not already there
      var existingStartOver = root.querySelector('[data-bli-start-over]');
      if (!existingStartOver) {
        var startOverBtn = document.createElement('button');
        startOverBtn.type = 'button';
        startOverBtn.setAttribute('data-bli-start-over', '1');
        startOverBtn.className = 'button button--secondary';
        startOverBtn.textContent = 'Start Over';
        startOverBtn.style.cssText = 'margin-top:22px;margin-bottom:8px;display:block;';
        startOverBtn.onclick = function() {
          form.reset();
          updateHelpers();
          showStep(1);
          app.scrollIntoView();
        };
        // Insert before the actions div (Shop/Contact buttons)
        var actionsDiv = root.querySelector('.bli-settings-guide__step[data-bli-step="9"] .bli-settings-guide__actions');
        if (actionsDiv && actionsDiv.parentNode) {
          actionsDiv.parentNode.insertBefore(startOverBtn, actionsDiv);
        }
      }

      renderCalculatorTable();
    }

    function validateStep() {
      if (currentStep === 1) return Boolean(getAnswer('laserType'));
      if (currentStep === 2) return Boolean(getAnswer('software'));
      if (currentStep === 3) return isWattageInRange(getAnswer('laserType'), getAnswer('wattage'));
      if (currentStep === 4) {
        if (getAnswer('laserType') !== 'CO2 Laser') return true;
        return Boolean(getAnswer('co2SpeedUnit'));
      }
      if (currentStep === 5) return Boolean(getAnswer('material'));
      if (currentStep === 6) return Boolean(getAnswer('markResult'));
      if (currentStep === 7) return Boolean(getAnswer('product'));
      return true;
    }

    function showStep(stepNumber) {
      // Skip step 4 (CO2 speed unit) for non-CO2 lasers
      if (stepNumber === 4 && getAnswer('laserType') !== 'CO2 Laser') {
        stepNumber = stepNumber > currentStep ? 5 : 3;
      }
      currentStep = stepNumber;
      // Filter software options to match selected laser type
      if (currentStep === 2) {
        var laserType = getAnswer('laserType');
        var softwareOpts = root.querySelectorAll('.bli-software-opt[data-for-laser]');
        for (var si = 0; si < softwareOpts.length; si++) {
          var forLasers = softwareOpts[si].getAttribute('data-for-laser') || '';
          if (forLasers.indexOf(laserType) > -1) {
            softwareOpts[si].classList.add('visible');
          } else {
            softwareOpts[si].classList.remove('visible');
            var inp = softwareOpts[si].querySelector('input');
            if (inp && inp.checked) inp.checked = false;
          }
        }
      }
      for (var i = 0; i < steps.length; i++) {
        var s = steps[i];
        Number(s.getAttribute('data-bli-step')) === currentStep ? addClass(s, 'is-active') : removeClass(s, 'is-active');
      }
      error.textContent = 'Please choose an option before continuing.';
      error.hidden = true;
      backButton.hidden = currentStep === 1;
      nextButton.textContent = currentStep === 8 ? 'Show My Settings' : currentStep === 9 ? 'Start Over' : 'Continue';
      stepLabel.textContent = 'Step ' + currentStep + ' of ' + totalSteps;
      progressBar.style.width = ((currentStep / totalSteps) * 100) + '%';
      if (currentStep === 9) updateResults();
    }

    var calculatorButton  = root.querySelector('[data-bli-calculator-button]');
    var funnelButton      = root.querySelector('[data-bli-funnel-button]');
    var calculatorSection = root.querySelector('#bli-calculator');

    if (calculatorButton && calculatorSection) {
      calculatorButton.onclick = function() {
        calculatorSection.scrollIntoView();
        addClass(calculatorSection, 'is-visible');
        var calcCard = root.querySelector('.bli-calculator-card');
        if (calcCard) addClass(calcCard, 'is-visible');
      };
    }
    if (funnelButton) {
      funnelButton.onclick = function() { app.scrollIntoView(); addClass(form, 'is-visible'); showStep(1); };
    }

    form.onchange = updateHelpers;
    form.oninput  = renderCalculatorTable;

    var calcLaserBtns = root.querySelectorAll('[data-calc-laser]');
    var calcWattage   = root.querySelector('[data-calc-wattage]');
    for (var ci = 0; ci < calcLaserBtns.length; ci++) {
      calcLaserBtns[ci].onclick = function() {
        for (var x = 0; x < calcLaserBtns.length; x++) removeClass(calcLaserBtns[x], 'is-active');
        addClass(this, 'is-active');
        calculatorLaser = this.getAttribute('data-calc-laser');
        calculatorSpeedUnit = calculatorLaser === 'CO2 Laser' ? 'percentage' : 'mm/s';

        // Immediately update table headers so they never show wrong label
        var _isFiber = calculatorLaser === 'Fiber Laser';
        var _fh = root.querySelector('[data-calc-header="frequency"]');
        var _ih = root.querySelector('[data-calc-header="lineInterval"]');
        if (_fh) _fh.textContent = _isFiber ? 'Frequency (kHz)' : 'DPI';
        if (_ih) _ih.textContent = _isFiber ? 'Hatch' : 'Line Interval';

        if (calcWattage) {
          if (calculatorLaser === 'Diode Laser') calcWattage.value = '40';
          if (calculatorLaser === 'CO2 Laser')   calcWattage.value = '50';
          if (calculatorLaser === 'Fiber Laser')  calcWattage.value = '30';
        }
        renderCalculatorTable();
      };
    }

    var calcMatBtns = root.querySelectorAll('[data-calc-material]');
    for (var mi = 0; mi < calcMatBtns.length; mi++) {
      calcMatBtns[mi].onclick = function() {
        for (var x = 0; x < calcMatBtns.length; x++) removeClass(calcMatBtns[x], 'is-active');
        addClass(this, 'is-active');
        calculatorMaterial = this.getAttribute('data-calc-material');
        renderCalculatorTable();
      };
    }
    if (calcWattage) calcWattage.oninput = renderCalculatorTable;

    nextButton.onclick = function() {
      if (currentStep === 9) {
        var sob = root.querySelector('[data-bli-start-over]');
        if (sob) sob.parentNode.removeChild(sob);
        var mb = root.querySelector('[data-bli-mismatch-banner]');
        if (mb) mb.parentNode.removeChild(mb);
        form.reset(); updateHelpers(); showStep(1); return;
      }
      if (!validateStep()) {
        if (currentStep === 2) {
          var range = getWattageRange(getAnswer('laserType'));
          error.textContent = range ? 'Please enter a wattage between ' + range.min + 'W and ' + range.max + 'W. If your wattage falls outside this range, our inks may not be compatible with your machine.' : 'Please enter your laser wattage before continuing.';
        } else {
          error.textContent = 'Please choose an option before continuing.';
        }
        error.hidden = false;
        return;
      }
      if (currentStep < totalSteps) showStep(currentStep + 1);
    };

    backButton.onclick = function() { if (currentStep > 1) showStep(currentStep - 1); };

    var disclaimerToggle = root.querySelector('[data-bli-disclaimer-toggle]');
    var disclaimerPanel  = root.querySelector('[data-bli-disclaimer-panel]');
    if (disclaimerToggle && disclaimerPanel) {
      disclaimerToggle.onclick = function() {
        var willOpen = disclaimerPanel.hidden;
        disclaimerPanel.hidden = !willOpen;
        disclaimerToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      };
    }

    var revealItems = [];
    function collectRevealItems(selector) {
      var found = root.querySelectorAll(selector);
      for (var i = 0; i < found.length; i++) revealItems.push(found[i]);
    }
    collectRevealItems('.bli-settings-guide__section');
    collectRevealItems('.bli-settings-guide__howto-step');
    collectRevealItems('.bli-settings-guide__form');
    collectRevealItems('.bli-calculator-card');

    function runReveal() {
      var trigger = window.innerHeight ? window.innerHeight * 0.65 : 520;
      for (var i = 0; i < revealItems.length; i++) {
        if (revealItems[i].getBoundingClientRect().top < trigger) addClass(revealItems[i], 'is-visible');
      }
    }
    if (window.addEventListener) { window.addEventListener('scroll', runReveal); window.addEventListener('resize', runReveal); }
    runReveal();
    showStep(1);
    forceWattageUnit();
    renderCalculatorTable();
  })();